<template>
  <div class="try-service">
    <a href="https://gisp.gov.ru/bimlib/" target="_blank" class="d-block">
      <bimButton class="try-service__button" label="Попробовать сервис" />
    </a>
    <bimText type="hint" bold class="try-service__info pt-4">Требуется регистрация в ГИСП</bimText>
  </div>
</template>

<script>
import bimButton from "@bimlib/components/bimButton"
import bimText from "@bimlib/components/bimText"
export default {
  name: "ButtonTryService",
  components: {
    bimButton,
    bimText
  }
}
</script>

<style lang="scss" scoped>
@import "./src/front_white/sass/components/color";

.try-service {
  display: inline-flex;
  align-items: center;
  flex-direction: column;


  .try-service__button {
    padding: 22px 36px;
    font-size: 18px;
    height: auto;
  }

  .try-service__info {
    color: $primary-color;
    line-height: 2;
    letter-spacing: 1px;
    text-transform: uppercase;
  }
}
</style>
